import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export const AddUserApi = async (
  {token,userName,type,password,confirmPassword,name}:Record<'token'|'userName'|'type'|'password'|'confirmPassword'|'name', string>
 
): Promise<AxiosResponse<any>> => {

  let data = {
    'userName': userName,
   'userRole': type,
   'password': password,
   'confirmPassword': confirmPassword,
   'name':name
   };

  var config:AxiosRequestConfig = {
    method: "post",
    url:
      "https://api.sht.distronix.in:4443/api/adminApi/addUser",
    headers: {
      'x-access-token': token ,
      'Content-Type': 'application/json'
    },
     data:data
  };

  // const result2 = ApiHandler({ config: config, retry: 0 })
  // const result = await axios(config)
  //   .then((res) => ({ data: res.data, success: true, error: "" }))
  //   .catch((e) => ({ error: e, success: false, data: [] }));
  // console.log(result);
  // return result;
  const response: AxiosResponse<any> = await axios(config);
  console.log("Add User: ", response.data)
  return response;
};
